import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { Modal } from '../../../components/ui/Modal.jsx';
import { Select } from '../../../components/ui/Select.jsx';
import { Textarea } from '../../../components/ui/Textarea.jsx';
import { Button } from '../../../components/ui/Button.jsx';
import { logisticsApi } from '../../../api/logistics.js';
import { useStoreOptions } from '../../../hooks/useStoreOptions.js';
import { ApiError } from '../../../api/client.js';
import { t } from '../../../lib/i18n.js';

import { ProductItemPicker } from './ProductItemPicker.jsx';

export function TransferFormModal({ open, onClose }) {
  const queryClient = useQueryClient();
  const { stores } = useStoreOptions({ enabled: open });

  const [fromStoreId, setFromStoreId] = useState('');
  const [toStoreId, setToStoreId] = useState('');
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState('');

  useEffect(() => { if (open) { setFromStoreId(''); setToStoreId(''); setItems([]); setNotes(''); } }, [open]);

  const mutation = useMutation({
    mutationFn: () => logisticsApi.createTransfer({
      fromStoreId, toStoreId, notes: notes || undefined,
      items: items.map((i) => ({ productId: i.productId, quantityRequested: Number(i.quantity) || 1 }))
    }),
    onSuccess: () => { toast.success('Trasferimento creato.'); queryClient.invalidateQueries({ queryKey: ['transfers'] }); onClose(); },
    onError: (err) => toast.error(err instanceof ApiError ? err.message : t('common.error'))
  });

  const valid = fromStoreId && toStoreId && fromStoreId !== toStoreId && items.length > 0;

  return (
    <Modal
      open={open}
      onClose={mutation.isPending ? undefined : onClose}
      title="Nuovo trasferimento"
      size="lg"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={mutation.isPending}>{t('common.cancel')}</Button>
          <Button onClick={() => mutation.mutate()} loading={mutation.isPending} disabled={!valid}>Crea</Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Select label="Da negozio" value={fromStoreId} onChange={(e) => setFromStoreId(e.target.value)}>
            <option value="">Seleziona...</option>
            {stores.map((s) => <option key={s._id} value={s._id}>{s.name}</option>)}
          </Select>
          <Select label="A negozio" value={toStoreId} onChange={(e) => setToStoreId(e.target.value)} error={fromStoreId && toStoreId && fromStoreId === toStoreId ? 'Deve differire' : undefined}>
            <option value="">Seleziona...</option>
            {stores.map((s) => <option key={s._id} value={s._id}>{s.name}</option>)}
          </Select>
        </div>
        <ProductItemPicker items={items} onChange={setItems} storeId={fromStoreId} />
        <Textarea label="Note" rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} />
      </div>
    </Modal>
  );
}
